import { RouteConfig } from "vue-router";

import { ApplicationRoute } from "./ap";
import { ApplicationAdminRoute } from "./admin";

export const Group: Array<RouteConfig> = [...ApplicationRoute, ...ApplicationAdminRoute];
